import { defineStore } from 'pinia';
import { useRewardAgent } from '~/composables/reward.agent';

export const useReward = defineStore('reward', {
  state: (): Reward => ({
    enabled: useRuntimeConfig().public.reward.enabled || false,
    provider: useRuntimeConfig().public.reward.provider?.toUpperCase() || null,
    rewardPoints: 0,
    multiplier: 0,
    cashValue: 0,
    rawData: null,
  }),

  getters: {
    redeemableCash: (state) => (points = state.rewardPoints) => 
      Number(points * state.multiplier),

    redeemablePoints: (state) => (cash = 0) => 
      Math.min((cash / state.multiplier), state.rewardPoints),
  },  

  actions: {
    async initialize() {
      const { user } = useAuth();
      const { $log } = useNuxtApp();

      try {
        const { getReward } = useRewardAgent();
        const { rewardPoints, multiplier, cashValue, rawData } = await getReward(user);
        this.rewardPoints = rewardPoints;
        this.multiplier = multiplier;
        this.cashValue = cashValue;
        this.rawData = rawData || null;
      } catch (error: any) {
        // $log.error(`Error fetching reward: ${error.message}`);
      }
    },

    async redeem(points = 0, options: any) {
      if (points <= 0) return false;

      const { user } = useAuth();
      const { $log } = useNuxtApp();
      try {
        const { redeemPoints } = useRewardAgent();
        await redeemPoints(user, points, options);
        // $log.info(`Redeemed ${points} points successfully`);
        return true;
      } catch (error: any) {
        // $log.error(`Redeem failed: ${error.message}`);
        return false;
      }
    },
  },

  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
  },
});
